import React, { useEffect } from "react";
import { AREAS_FULL, SITE } from "@/data/site";
import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";

const AreasDeAtuacao = () => {
    const { hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.getElementById(hash.replace("#", ""));
            if (el) {
                setTimeout(
                    () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
                    120,
                );
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [hash]);

    return (
        <div data-testid="page-areas">
            <SEO
                title="Áreas de Atuação"
                description="16 áreas de atuação da ACD Advogados: Direito Penal, Civil, Trabalho, Administrativo, Fiscal, Comercial, Arbitragem, Imobiliário, Propriedade Intelectual, Atos Notariais e mais."
                canonicalPath="/areas-de-atuacao"
            />
            {/* Page hero */}
            <section className="relative py-20 md:py-28 px-6 bg-[var(--acd-navy-900)] text-white overflow-hidden">
                <div className="absolute inset-0 opacity-25 bg-[url('https://customer-assets.emergentagent.com/job_advogados-staging/artifacts/komhol4o_pexels-thorl5-2154653228-33672640.webp')] bg-cover bg-center" />
                <div className="absolute inset-0 bg-gradient-to-r from-[var(--acd-navy-950)]/95 to-[var(--acd-navy-900)]/70" />
                <div className="relative z-10 max-w-7xl mx-auto text-center">
                    <span className="acd-eyebrow">Áreas de Atuação</span>
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mt-3">
                        Soluções Jurídicas à Medida de Cada Desafio
                    </h1>
                </div>
            </section>

            {/* Areas list */}
            <section className="py-20 md:py-24 px-6">
                <div className="max-w-4xl mx-auto space-y-16">
                    {AREAS_FULL.map((a, idx) => (
                        <article
                            id={a.id}
                            key={a.id}
                            className="scroll-mt-24"
                            data-testid={`full-area-${a.id}`}
                        >
                            <div className="flex items-start gap-4 mb-4">
                                <div className="shrink-0 w-12 h-12 rounded-lg bg-gradient-to-br from-[var(--acd-blue-600)] to-[var(--acd-orange)] text-white flex items-center justify-center font-bold text-lg">
                                    {String(idx + 1).padStart(2, "0")}
                                </div>
                                <div>
                                    <h2 className="text-2xl md:text-3xl font-bold text-[var(--acd-navy-900)] mb-3">
                                        {a.title}
                                    </h2>
                                </div>
                            </div>
                            {a.body.map((p, i) => (
                                <p
                                    key={i}
                                    className="text-[color:var(--acd-muted)] leading-relaxed mb-3"
                                >
                                    {p}
                                </p>
                            ))}
                            {a.list && (
                                <ul className="list-disc pl-5 space-y-1 text-[color:var(--acd-muted)] mb-3">
                                    {a.list.map((it) => (
                                        <li key={it}>{it}</li>
                                    ))}
                                </ul>
                            )}
                            {a.extra &&
                                a.extra.map((p, i) => (
                                    <p
                                        key={i}
                                        className="text-[color:var(--acd-muted)] leading-relaxed mb-3"
                                    >
                                        {p}
                                    </p>
                                ))}
                            <a
                                href={SITE.whatsappUrlAppointment}
                                target="_blank"
                                rel="noreferrer"
                                className="acd-btn-gradient mt-4"
                            >
                                Mais informações
                            </a>
                        </article>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default AreasDeAtuacao;
